import ServiceLocator from 'live/services/service-locator'
import { LiveApi } from 'live/lib/api'
import i18n from 'live/services/i18n'
import authorization from 'live/services/authorization'

try {
    document.addEventListener('DOMContentLoaded', function() {
        require('./init')
    })
} catch (e) {
    console.log(e)
}

require('./pwda/app')
require('./pwda_normalizer/app')
